<template>
  <div class="flex flex-column col-12 my1">
    <div v-for="(line, lineIndex) in form" :key="lineIndex" class="flex flex-wrap col-12">
      <div
        v-for="(input, index) in line"
        :key="index"
        class="flex sm-col-12 col-6"
        :class="[{ 'col-12': input.type === 'radio' }]"
      >
        <div v-if="input.key === 'gender'" class="flex flex-column col-12 mx1">
          <span class="my1 h6 bold">{{ input.label }}</span>
          <div class="flex col-12">
            <div class="flex col-12">
              <div v-for="(option, i) in input.options" :key="i" class="flex" :class="option.style">
                <input
                  :checked="input.value === option.value"
                  :type="input.type"
                  :name="input.key"
                  :value="option.value"
                  @input="updateCheckbox"
                >
                <span class="h6">{{ option.text }}</span>
              </div>
            </div>
            <i v-if="input.value" class="icon icon-check mr2"></i>
          </div>
        </div>

        <div
          v-else-if="input.key === 'mobilephone' || input.key === 'telephone'"
          class="flex flex-column col-12 mx1 mb2"
        >
          <span class="my1 h6 bold" :class="[{ 'red': mobileValidation && !mobileValidation?.valid }]">{{ input.label
          }}</span>
          <vue-tel-input
            v-model="input.value"
            mode="international"
            :input-options="{ placeholder: '' }"
            :preferred-countries="['FR']"
            default-country="FR"
            class="h3 fields-height"
            :class="{ 'invalid-field': allFieldsValid[input.key] }"
            @validate="handleValidation"
            @update:model-value="updatePhoneNumber(input.key, $event)"
          />
          <span v-if="allFieldsValid[input.key]" class="bold h6n red"> {{ allFieldsValid[input.key] }}</span>
          <i
            v-if="!allFieldsValid[input.key] && mobileValidation?.valid"
            class="icon icon-check icon-mobilephone-input absolute"
          ></i>
        </div>

        <div v-else-if="input.type === 'select'" class="flex flex-column col-12 mx1">
          <span class="my1 h6 bold">{{ input.label }}</span>
          <select
            v-model="input.value"
            class="px2 py1 col-12 mb2 h4 border-radius-3 dark-grey-bd fields-height"
            @change="updateFormValidity"
          >
            <option v-for="(option, optionIndex) in input.options" :key="optionIndex" :value="option.value">
              {{ option.text }}
            </option>
          </select>
          <i class="icon icon-inside-select absolute icon-chevron-down"></i>
        </div>

        <div v-else class="flex col-12">
          <div class="flex col-12">
            <InputField
              :value="input.value"
              :label="input.label"
              :name="input.key"
              :type="input.type"
              :caps="false"
              :required="input.required"
              :placeholder="input.placeholder"
              :error="allFieldsValid[input.key]"
              class="col-12"
              @update:value="v => { input.value = v; }"
              @change="updateFormValidity"
            />
            <i v-if="!allFieldsValid[input.key] && input.value" class="icon icon-check icon-inside-input absolute"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-if="formWarnings" class="flex mt2 mb3 center justify-center items-center red-bd mx1 p1">
      <i class="icon h5 red icon-stop mr2" style="padding-top:6px"></i><span class="h4 red center">{{ formWarnings.error }}
        {{ formWarnings.showAdditionalError ? 'Veuillez utiliser des informations de contact différentes.' : '' }}</span>
    </div>
    <i v-if="showScrollTop" class="pointer icon icon-triangle-up scroll-top" @click="scrollToTop"></i>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import { formFields, checkError, getRequiredFields } from '@/utils/utils';
import InputField from '@/components/participants/InputField.vue';

import 'vue-tel-input/vue-tel-input.css';

export default {
  components: { InputField, VueTelInput },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    formValid: {
      type: Boolean,
      default: false
    },
    formType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: null,
      mobileValidation: null,
      showScrollTop: false
    };
  },
  computed: {
    isCreate () {
      return !Object.keys(this.data || {}).length;
    },
    cartItem () {
      return this.$store.state.cartItem;
    },
    selectedParticipant () {
      return this.cartItem.participants[0] || {};
    },
    customerForm () {
      return this.formType === 'createCustomer' || this.formType === 'editCustomer';
    },
    contactForm () {
      return this.formType === 'emergencyContact';
    },
    bodyData () {
      return this.generateBody();
    },
    isFormValid () {
      if (this.contactForm) {
        return this.getRequiredFields(this.formType).every(field => !!this.bodyData[field]) && !Object.keys(this.allFieldsValid).length && this.bodyData.email === this.bodyData.email_confirmation;
      }
      return this.getRequiredFields(this.formType, this.isCreate ? [] : ['uuid']).every(field => !!this.bodyData[field]) && !Object.keys(this.allFieldsValid).length;
    },
    allFieldsValid () {
      const errors = {};

      this.form.map(line => {
        line.map(input => {
          if ((input.required && input.value === null) || (input.required && input.value === undefined) || ((input.key === 'mobilephone' || input.key === 'telephone') && this.mobileValidation === null)) {
            return;
          }

          const globalValidation = this.checkError(input.value, input.key, this.mobileValidation?.valid, input.required);
          if (globalValidation) {
            errors[input.key] = globalValidation;
          }
        });
      });
      return errors;
    },
    formWarnings () {
      return this.$store.state.formError;
    }
  },
  mounted () {
    this.$store.commit('setFormError', null);
    const contentElement = document.getElementById('contentDiv');
    if (contentElement) {
      contentElement.addEventListener('scroll', () => {
        if (contentElement.scrollTop > 0) {
          this.showScrollTop = true;
          return;
        }
        this.showScrollTop = false;
      });
    }

    this.form = formFields[this.formType];
    this.clearInputs();

    if (!this.isCreate) {
      this.fillInputs();
      this.updateFormValidity();
    }
  },
  methods: {
    checkError,
    getRequiredFields,
    fillInputs () {
      this.form.map(line => {
        line.map(input => {
          Object.entries(this.data).map(([name, value]) => {
            switch (input.key) {
              case 'country':
                if (name === 'country') {
                  const index = input.options.findIndex(opt => opt.value.toLowerCase() === (value || '').toLowerCase() || opt.text.toLowerCase() === (value || '').toLowerCase());

                  if (index !== -1) {
                    input.value = input.options[index].value;
                  }
                }
                break;
              case name:
                input.value = value;
                break;
              default:
                break;
            }
          });
        });
      });
    },
    clearInputs () {
      this.form.map(line => {
        line.map(input => {
          input.value = (input.key === 'mobilephone' || input.key === 'telephone') ? '' : null;
        });
      });
    },
    /* build body (customer/contact) to send in the request */
    generateBody () {
      let body = {};
      this.form.map(line => {
        line.map(input => {
          body[input.key] = input.value;
          return input;
        });
      });
      if (!this.isCreate && this.customerForm) {
        body = { uuid: this.data.uuid, ...body };
      }
      return body;
    },
    /* update InputFields without delay */
    handleChange (event) {
      this.form.map(line => {
        line.map(input => {
          if (input.key === event.name) {
            input.value = event.value;
          }
        });
      });
    },
    updateFormValidity (event) {
      if (event) {
        this.handleChange(event);
      }
      if (this.isFormValid) {
        if (this.customerForm) {
          this.$store.commit('setCartItem', { ...this.cartItem, participants: [this.generateBody()] });
          this.$store.commit('setFormValid', true);
        }
        if (this.contactForm) {
          const emergencyContact = this.generateBody();
          delete emergencyContact.email_confirmation;

          this.$store.commit('setCartItem', { ...this.cartItem, participants: [{ ...this.selectedParticipant, emergency_contacts: Array.isArray(emergencyContact) ? emergencyContact : [emergencyContact] }] });
          this.$store.commit('setFormValid', true);
        }
      } else {
        this.$store.commit('setFormValid', false);
      }
    },
    /* Activate validation when 'gender' is the last one to be filled */
    updateCheckbox (event) {
      if (event && event.target && event.target.name && event.target.value) {
        this.updateFormValidity({ name: event.target.name, value: event.target.value });
      }
    },
    /* Activate validation when 'mobilephone/telephone' is the last one to be filled */
    updatePhoneNumber (name, value) {
      this.updateFormValidity({ name, value });
    },
    handleValidation ($event) {
      if (Object.keys($event).length) {
        this.mobileValidation = $event;
      }
    },
    scrollToTop () {
      const elem = document.querySelector('#contentDiv');
      if (elem) {
        elem.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
input[type="radio"] {
  margin: 0.2rem;
  margin-right: 0.5rem;
}

input[type="radio"]:checked::after {
  box-shadow: inset 0 0 0 2px var(--white);
  background-color: var(--strong-blue);
  border-color: var(--strong-blue)
}

:deep(.vue-tel-input .vti__input) {
  font-size: 1.15rem;
  padding: 3px 0 0 0;
}

.invalid-field {
  border: 1px solid red;
}

.fields-height {
  height: 41px;
}

.scroll-top {
  display: none;
}

.icon-inside-select:before {
  top: -45px;
  right: 0.9rem;
  position: absolute;
}

@media (max-width: 40rem) {
  .scroll-top {
    display: block;
    position: fixed;
    padding: 0.5rem;
    font-size: 1.5rem;
    bottom: 120px;
    right: 10px;
    z-index: 12;
    color: white;
    background-color: black;
    border-radius: 10px;
  }
}
</style>
